import React, { useContext } from 'react';
import { map } from 'lodash';
import cn from "classnames";
import { IndexData } from "../../index-context";
import { biggerThan, showedAverageValue } from "../../helpers";
import OverviewStatusBar from "./overview-status-bar";

const TrOverviewAttributeRatings = ({
  data, checkedConcepts, attributeRatings
}) => {
  const { sort, averageMode, init } = useContext(IndexData);

  return (
    <>
      {
        map(attributeRatings, (values, title) => {
          if (values.avg_hide_for_custom !== undefined && values.avg_hide_for_custom) {
            return (null);
          }
          const avgValue = values?.avg?.top2 ? values.avg.top2 : '0%';
          return (
            <tr key={ title }>
              <td className="table-comparison_name-cell table-concept-overview_td-title">
                <span className={ cn({ 'sort-link -current': title === sort }) }>
                  {values.real_attribute_title || title}
                </span>
              </td>
              <td className="table-concept-overview_avg-col">
                {
                  !!avgValue && ((init.isInternal && data.view !== "client") || averageMode !== 'platform') &&
                  <div className="table-concept-overview_avg-inner">
                    <span
                      className="table-concept-overview_avg-value"
                      style={ { 'bottom': avgValue } }
                    >
                      <span
                        className={
                          cn(
                            'table-concept-overview_avg-value-text',
                            { '-big': biggerThan(avgValue, 75)
                            }
                          )
                        }
                      >
                        { showedAverageValue(values, averageMode, false, init.isInternal, data.view) }
                      </span>
                    </span>
                  </div>
                }
              </td>
              {
                map(checkedConcepts, (concept, i) => (
                  <td
                    className={
                      cn(
                        "table-concept-overview_td-chart",
                        {
                          "-first": !i,
                          "-last": i === checkedConcepts.length - 1
                        }
                      )
                    }
                    key={ i }
                  >
                    <OverviewStatusBar values={ values[concept.id] } box="top2" />
                  </td>
                ))
              }
            </tr>
          );
        })
      }
    </>
  );
};

export default TrOverviewAttributeRatings;
